import { createContext, useContext, useMemo, useState } from 'react';
import { ClipLoader } from 'react-spinners';

type PageLoadingContext = {
  showPageLoading: (key: string) => void;
  hidePageLoading: (key: string) => void;
  purgeKeys: () => void;
};

export const PageLoadingContext = createContext<PageLoadingContext | undefined>(undefined);

export const PageLoadingProvider = ({ children }) => {
  const [loadingKeys, setLoadingKeys] = useState<string[]>([]);
  const contextValue = useMemo(
    () =>
      ({
        showPageLoading: (key: string) => {
          setLoadingKeys(prevState => [...prevState, key]);
        },
        hidePageLoading: (key: string) => {
          setLoadingKeys(prevState => prevState.filter(x => x !== key));
        },
        purgeKeys: () => setLoadingKeys([]),
      }) as PageLoadingContext,
    [setLoadingKeys],
  );

  return (
    <PageLoadingContext.Provider value={contextValue}>
      {loadingKeys?.length > 0 && <PageLoading />}
      {children}
    </PageLoadingContext.Provider>
  );
};

export const PageLoading = () => (
  <div className='w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50'>
    <div className='flex justify-center items-center mt-[50vh]'>
      <ClipLoader color={'blue'} />
    </div>
  </div>
);

export const usePageLoading = () => {
  const context = useContext(PageLoadingContext);
  if (!context) {
    throw new Error('Must be used within a PageLoadingProvider');
  }
  return context;
};
